export default "__VITE_ASSET__5P1gK33M__"